import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import UpTransition from '../../../shared/UpTransition/UpTransition';
import { Trans } from 'react-i18next';

type Props = {
  open: boolean;
  name: string;
  handleClose: (success: boolean) => void;
};

const ConfirmDialog = ({ open, name, handleClose }: Props): JSX.Element => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby={'confirm-dialog-title'}
      aria-describedby={'confirm-dialog-description'}
      TransitionComponent={UpTransition}
    >
      <DialogTitle id={'confirm-dialog-title'}>
        <Trans>Confirm</Trans>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={'confirm-dialog-description'}>
          {/* TODO: use internationalization */}
          <Trans>Are you sure you want to irreversibly delete the selected results?</Trans>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>
          <Trans>No</Trans>
        </Button>
        <Button onClick={() => handleClose(true)}>
          <Trans>Yes</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
